var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"large":"","href":"https://github.com/users/johnleider/sponsorship"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" $mdiGithub ")]),_vm._v(" "+_vm._s(_vm.$t('become-a-sponsor'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }